module.exports = {
  addDays: require('./add_days'),
  addHours: require('./add_hours'),
  addISOYears: require('./add_iso_years'),
  addMilliseconds: require('./add_milliseconds'),
  addMinutes: require('./add_minutes'),
  addMonths: require('./add_months'),
  addQuarters: require('./add_quarters'),
  addSeconds: require('./add_seconds'),
  addWeeks: require('./add_weeks'),
  addYears: require('./add_years'),
  closestIndexTo: require('./closest_index_to'),
  closestTo: require('./closest_to'),
  compareAsc: require('./compare_asc'),
  compareDesc: require('./compare_desc'),
  differenceInCalendarDays: require('./difference_in_calendar_days'),
  differenceInCalendarISOWeeks: require('./difference_in_calendar_iso_weeks'),
  differenceInCalendarISOYears: require('./difference_in_calendar_iso_years'),
  differenceInCalendarMonths: require('./difference_in_calendar_months'),
  differenceInCalendarQuarters: require('./difference_in_calendar_quarters'),
  differenceInCalendarWeeks: require('./difference_in_calendar_weeks'),
  differenceInCalendarYears: require('./difference_in_calendar_years'),
  differenceInDays: require('./difference_in_days'),
  differenceInHours: require('./difference_in_hours'),
  differenceInISOYears: require('./difference_in_iso_years'),
  differenceInMilliseconds: require('./difference_in_milliseconds'),
  differenceInMinutes: require('./difference_in_minutes'),
  differenceInMonths: require('./difference_in_months'),
  differenceInQuarters: require('./difference_in_quarters'),
  differenceInSeconds: require('./difference_in_seconds'),
  differenceInWeeks: require('./difference_in_weeks'),
  differenceInYears: require('./difference_in_years'),
  distanceInWords: require('./distance_in_words'),
  distanceInWordsToNow: require('./distance_in_words_to_now'),
  eachDay: require('./each_day'),
  endOfDay: require('./end_of_day'),
  endOfHour: require('./end_of_hour'),
  endOfISOWeek: require('./end_of_iso_week'),
  endOfISOYear: require('./end_of_iso_year'),
  endOfMinute: require('./end_of_minute'),
  endOfMonth: require('./end_of_month'),
  endOfQuarter: require('./end_of_quarter'),
  endOfSecond: require('./end_of_second'),
  endOfToday: require('./end_of_today'),
  endOfTomorrow: require('./end_of_tomorrow'),
  endOfWeek: require('./end_of_week'),
  endOfYear: require('./end_of_year'),
  endOfYesterday: require('./end_of_yesterday'),
  format: require('./format'),
  getDate: require('./get_date'),
  getDay: require('./get_day'),
  getDayOfYear: require('./get_day_of_year'),
  getDaysInMonth: require('./get_days_in_month'),
  getDaysInYear: require('./get_days_in_year'),
  getHours: require('./get_hours'),
  getISOWeek: require('./get_iso_week'),
  getISOWeeksInYear: require('./get_iso_weeks_in_year'),
  getISOYear: require('./get_iso_year'),
  getMilliseconds: require('./get_milliseconds'),
  getMinutes: require('./get_minutes'),
  getMonth: require('./get_month'),
  getQuarter: require('./get_quarter'),
  getSeconds: require('./get_seconds'),
  getYear: require('./get_year'),
  isAfter: require('./is_after'),
  isBefore: require('./is_before'),
  isDate: require('./is_date'),
  isEqual: require('./is_equal'),
  isFirstDayOfMonth: require('./is_first_day_of_month'),
  isFriday: require('./is_friday'),
  isFuture: require('./is_future'),
  isLastDayOfMonth: require('./is_last_day_of_month'),
  isLeapYear: require('./is_leap_year'),
  isMonday: require('./is_monday'),
  isPast: require('./is_past'),
  isSameDay: require('./is_same_day'),
  isSameHour: require('./is_same_hour'),
  isSameISOWeek: require('./is_same_iso_week'),
  isSameISOYear: require('./is_same_iso_year'),
  isSameMinute: require('./is_same_minute'),
  isSameMonth: require('./is_same_month'),
  isSameQuarter: require('./is_same_quarter'),
  isSameSecond: require('./is_same_second'),
  isSameWeek: require('./is_same_week'),
  isSameYear: require('./is_same_year'),
  isSaturday: require('./is_saturday'),
  isSunday: require('./is_sunday'),
  isThisHour: require('./is_this_hour'),
  isThisISOWeek: require('./is_this_iso_week'),
  isThisISOYear: require('./is_this_iso_year'),
  isThisMinute: require('./is_this_minute'),
  isThisMonth: require('./is_this_month'),
  isThisQuarter: require('./is_this_quarter'),
  isThisSecond: require('./is_this_second'),
  isThisWeek: require('./is_this_week'),
  isThisYear: require('./is_this_year'),
  isThursday: require('./is_thursday'),
  isToday: require('./is_today'),
  isTomorrow: require('./is_tomorrow'),
  isTuesday: require('./is_tuesday'),
  isValid: require('./is_valid'),
  isWednesday: require('./is_wednesday'),
  isWeekend: require('./is_weekend'),
  isWithinRange: require('./is_within_range'),
  isYesterday: require('./is_yesterday'),
  lastDayOfISOWeek: require('./last_day_of_iso_week'),
  lastDayOfISOYear: require('./last_day_of_iso_year'),
  lastDayOfMonth: require('./last_day_of_month'),
  lastDayOfQuarter: require('./last_day_of_quarter'),
  lastDayOfWeek: require('./last_day_of_week'),
  lastDayOfYear: require('./last_day_of_year'),
  max: require('./max'),
  min: require('./min'),
  parse: require('./parse'),
  setDate: require('./set_date'),
  setDay: require('./set_day'),
  setDayOfYear: require('./set_day_of_year'),
  setHours: require('./set_hours'),
  setISOWeek: require('./set_iso_week'),
  setISOYear: require('./set_iso_year'),
  setMilliseconds: require('./set_milliseconds'),
  setMinutes: require('./set_minutes'),
  setMonth: require('./set_month'),
  setQuarter: require('./set_quarter'),
  setSeconds: require('./set_seconds'),
  setYear: require('./set_year'),
  startOfDay: require('./start_of_day'),
  startOfHour: require('./start_of_hour'),
  startOfISOWeek: require('./start_of_iso_week'),
  startOfISOYear: require('./start_of_iso_year'),
  startOfMinute: require('./start_of_minute'),
  startOfMonth: require('./start_of_month'),
  startOfQuarter: require('./start_of_quarter'),
  startOfSecond: require('./start_of_second'),
  startOfToday: require('./start_of_today'),
  startOfTomorrow: require('./start_of_tomorrow'),
  startOfWeek: require('./start_of_week'),
  startOfYear: require('./start_of_year'),
  startOfYesterday: require('./start_of_yesterday'),
  subDays: require('./sub_days'),
  subHours: require('./sub_hours'),
  subISOYears: require('./sub_iso_years'),
  subMilliseconds: require('./sub_milliseconds'),
  subMinutes: require('./sub_minutes'),
  subMonths: require('./sub_months'),
  subQuarters: require('./sub_quarters'),
  subSeconds: require('./sub_seconds'),
  subWeeks: require('./sub_weeks'),
  subYears: require('./sub_years')
}
